module.exports = __webpack_public_path__ + "img/summary-for-management.089a0948.png";